import React from 'react'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {SendConfirmMailContent} from '../../Components/CompleteContentBlocks/SendConfirmMailContent'
import {useTranslation} from 'react-i18next'

export const MembersSendMailForVerificationIdentityPage: React.VFC = () => {
  const {t} = useTranslation('member')
  return (
    <MembersPageTemplate>
      <PageTitle>{'パスワード再設定用メール送信完了'}</PageTitle>

      <SendConfirmMailContent
        title={'メール送信完了'}
        topMessage={'パスワード再設定用メールを送信しました。\n' +
          '届いたメールのワンタイムURLからパスワードの再設定を行ってください。\n' +
          'メールに記載されているURLの有効期限は3時間となっています。'}
        note={[
          t('パスワード再設定用メール送信完了.注記 有効メールアドレス'),
          t('パスワード再設定用メール送信完了.注記 メール受信設定'),
        ]}
        dataTestId="block-send-confirm-mail"
      />
    </MembersPageTemplate>
  )
}
